import { createSelector } from '@ngrx/store';
import { AppState } from '../AppState';
import { IntegrationsState } from './reducer';

const integratiosState = (state: AppState) => state.integrations;

export const integrationsSatus = createSelector(
  integratiosState,
  (state: IntegrationsState) => state
);